import type { DatasetCardProps } from "./dataset-card.type";
import type { DatasetActionsProps } from "@/modules/dataset/dataset-actions";

import { Card, Typography } from "antd";

import { DatasetActions } from "@/modules/dataset/dataset-actions";
import { DatasetWrapper } from "@/modules/dataset/dataset-wrapper";

import { DatasetCardDescription } from "./dataset-card-description";

import "./dataset-card.style.less";

const { Title } = Typography;

export const DatasetCard = ({
  datasetType,
  template,
  dataset,
  loading,
  disabled,
  actionsPlacement = "cardExtra",
  beforeActions,
  afterActions,
  children,
  ...cardProps
}: DatasetCardProps) => {
  const actionsProps: DatasetActionsProps = {
    datasetType,
    dataset,
    loading,
    disabled,
    beforeActions,
    afterActions,
  };

  return (
    <Card
      {...cardProps}
      title={<Title level={3}>{template.name}</Title>}
      className="dataset-card"
      extra={
        actionsPlacement === "cardExtra" && <DatasetActions {...actionsProps} />
      }
    >
      <DatasetCardDescription template={template} loading={loading} />
      <div className="dataset-card-content">
        {actionsPlacement === "beforeContent" && (
          <DatasetActions {...actionsProps} />
        )}
        <DatasetWrapper datasetType={datasetType} loading={loading}>
          {children}
        </DatasetWrapper>
      </div>
    </Card>
  );
};
